define('glu/listBuilder/listBuilderLayout',['require','../layout','../collectionView','../collection','../$document','./listBuilderItemView','../locale','../dialog','../util','../log','jui/draggable','jui/droppable','hbs!./listBuilderLayout.hbs'],function(require) {
    'use strict';

    var Layout = require('../layout'),
        CollectionView = require('../collectionView'),
        Collection = require('../collection'),
        $document = require('../$document'),
        ListBuilderItemView = require('./listBuilderItemView'),
        locale = require('../locale'),
        dialog = require('../dialog'),
        util = require('../util'),
        log = require('../log');

    require('jui/draggable');
    require('jui/droppable');

    var fuzzyMatch = function(haystack, needle) {
        if (needle.length === 0) {
            return true;
        }
        var index = haystack.indexOf(needle[0]);
        if (index === -1) {
            return false;
        }
        return fuzzyMatch(haystack.slice(index + 1), needle.slice(1));
    };

    return Layout.extend({

        template: require('hbs!./listBuilderLayout.hbs'),
        className: 'list-builder',

        ui: {
            sourceListSearchFilter: '.source-list-search-filter',
            sourceListSearchFilterToggle: '.source-list-search-filter-toggle',
            moveSelectedItems: '[data-action="move-selected-items"]',
            moveAllItems: '[data-action="move-all-items"]',
            removeSelectedItems: '[ data-action="remove-selected-items"]',
            removeAllItems: '[data-action="remove-all-items"]',
            clearSourceSelection: '[data-action="clear-source-selection"]',
            clearTargetSelection: '[data-action="clear-target-selection"]'
        },

        events: {
            'click @ui.sourceListSearchFilterToggle': 'toggleFilter',
            'keyup @ui.sourceListSearchFilter': 'applySearchFilter',
            'click @ui.moveSelectedItems': 'moveSelectedItems',
            'click @ui.moveAllItems': 'moveAllItems',
            'click @ui.removeSelectedItems': 'removeSelectedItems',
            'click @ui.removeAllItems': 'removeAllItems',
            'click @ui.clearSourceSelection': 'clearSourceSelection',
            'click @ui.clearTargetSelection': 'clearTargetSelection',
            'dblclick .list-builder-item': 'moveItemBetweenCollections'
        },

        initialize: function(options) {
            this.labelView = options.labelView;
            this.sourceCollection = options.dataPersist ? options.sourceCollection : this.setLocalCollection(options.sourceCollection);
            this.targetCollection = options.dataPersist ? options.targetCollection : this.setLocalCollection(options.targetCollection);
            this.groups = options.groups;
            this.text = this.setText(options);

            util.bindAll(this, 'onDragAndDrop');

            this.setSourceCollectionIndices();

            this.listenTo(this.targetCollection, 'add remove reset', this.targetCollectionUpdated);
            this.listenTo(this.sourceCollection, 'add remove reset', this.sourceCollectionUpdated);

            this.sourceList = this.buildListCollectionView('source-list', this.sourceCollection);
            this.targetList = this.buildListCollectionView('target-list', this.targetCollection);
        },

        templateHelpers: function() {
            return {
                cid: this.cid,
                moveSelectedItems: this.text.moveSelectedItems,
                moveAllItems: this.text.moveAllItems,
                removeSelectedItems: this.text.removeSelectedItems,
                removeAllItems: this.text.removeAllItems,
                filter: this.text.filter,
                sourceListHeader: this.text.sourceListHeader,
                targetListHeader: this.text.targetListHeader,
                clearSourceSelection: this.text.clearSourceSelection,
                clearTargetSelection: this.text.clearTargetSelection
            };
        },

        onRender: function() {
            this.sortLists();
        },

        setSourceCollectionIndices: function() {
            this.sourceCollection.each(function(model, i) {
                model.set('sourceIndex', i);
            });

            if (!this.sourceCollection.comparator) {
                this.sourceCollection.comparator = 'sourceIndex';
            }
        },

        buildListCollectionView: function(className, collection) {
            return new CollectionView({
                tagName: 'ul',
                className: className,
                collection: collection,
                itemView: ListBuilderItemView,
                itemViewOptions: {
                    layout: this,
                    labelView: this.labelView
                }
            });
        },

        targetCollectionUpdated: function() {
            this.trigger('targetListUpdated', this.targetCollection.toJSON());
        },

        sourceCollectionUpdated: function() {
            this.trigger('sourceListUpdated', this.sourceCollection.toJSON());
        },

        getSourceList: function() {
            return this.sourceCollection.toJSON();
        },

        getTargetList: function() {
            return this.targetCollection.toJSON();
        },

        setText: function(options) {
            options.text = options.text || {};
            return util.extend(options.text, {
                moveSelectedItems: options.text.moveSelectedItems || locale.get('moveSelectedItems'),
                moveAllItems: options.text.moveAllItems || locale.get('moveAllItems'),
                removeSelectedItems: options.text.removeSelectedItems || locale.get('removeSelectedItems'),
                removeAllItems: options.text.removeAllItems || locale.get('removeAllItems'),
                filter: options.text.filter || locale.get('filter'),
                sourceListHeader: options.text.sourceListHeader || locale.get('sourceListHeader'),
                targetListHeader: options.text.targetListHeader || locale.get('targetListHeader'),
                clearSourceSelection: options.text.clearSourceSelection || locale.get('clearSourceSelection'),
                clearTargetSelection: options.text.clearTargetSelection || locale.get('clearTargetSelection')
            });
        },

        setLocalCollection: function(collection) {
            if (util.isUndefined(collection) || util.isArray(collection)) {
                return new Collection(collection || []);
            }
            return collection.clone();
        },

        initializeDragAndDrop: function() {
            var self = this;
            this.$('.list-builder-item').draggable({
                helper: 'clone',
                appendTo: '.list-builder',
                start: function(event, ui) {
                    ui.helper.width(self.$(event.target).width());
                    ui.helper.height(self.$(event.target).height());
                    self.$(event.target).hide();
                },
                stop: function(event) {
                    self.$(event.target).show();
                }
            });

            this.$('.target-list, .source-list').droppable({
                drop: function(event, ui) {
                    self.onDragAndDrop(ui.draggable, self.$(this));
                },
                accept: function(draggable) {
                    return self.isDropAccepted(draggable, self.$(this));
                },
                activeClass: 'ui-state-active',
                hoverClass: 'drop-hover',
                greedy: true
            });

            this.$('.target-list .list-builder-item').droppable({
                drop: function(event, ui) {
                    self.onDragAndDrop(ui.draggable, self.$(this));
                },
                accept: function(draggable) {
                    return self.isDropAccepted(draggable, self.$(this));
                },
                activeClass: 'ui-state-active',
                hoverClass: 'drop-hover',
                greedy: true
            });

        },

        onDragAndDrop: function(draggable, droppable) {
            var item;

            if (draggable.parent().hasClass('target-list')) {
                item = this.targetCollection.get(draggable.data('itemId'));
            } else {
                item = this.sourceCollection.get(draggable.data('itemId'));
            }


            if (droppable.is('ul')) {
                if (droppable.hasClass('target-list')) {
                    if (draggable.parent().hasClass('source-list')) {
                        this.sourceCollection.remove(item);
                        this.targetCollection.add(item);
                    } else {
                        this.targetCollection.remove(item);
                        this.targetCollection.add(item);
                    }
                } else {
                    this.targetCollection.remove(item);
                    this.sourceCollection.add(item);
                }
            } else {

                if (droppable.parent().hasClass('target-list')) {
                    if (draggable.parent().hasClass('target-list')) {
                        this.targetCollection.remove(item);
                        this.targetCollection.add(item, {
                            at: droppable.index()
                        });
                    } else {
                        this.sourceCollection.remove(item);
                        this.targetCollection.add(item, {
                            at: droppable.index()
                        });
                    }
                } else {
                    if (draggable.parent().hasClass('source-list')) {
                        this.sourceCollection.remove(item);
                        this.sourceCollection.add(item);
                    } else {
                        this.targetCollection.remove(item);
                        this.sourceCollection.add(item);
                    }

                }

            }

            this.sortLists();
        },


        isDropAccepted: function() {
            return true;
        },

        moveItemBetweenCollections: function(e) {
            var item = $document.find(e.currentTarget),
                itemId = item.data('itemId'),
                collectionItem;

            if (item.parent().hasClass('source-list')) {
                collectionItem = this.sourceCollection.get(itemId);
                this.sourceCollection.remove(collectionItem);
                this.targetCollection.add(collectionItem);
            } else {
                collectionItem = this.targetCollection.get(itemId);
                this.targetCollection.remove(collectionItem);
                this.sourceCollection.add(collectionItem);
            }

            this.sortLists();
        },

        toggleFilter: function(e) {
            e.stopPropagation();
            this.ui.sourceListSearchFilter.toggleClass('is-open');
            this.applySearchFilter();
            return false;
        },

        applySearchFilter: function() {
            var $filter = this.ui.sourceListSearchFilter;
            var filterText = $filter.hasClass('is-open') ? $filter.val().trim() : '';

            var self = this;
            this.sourceList.$('> *').each(function(index, element) {
                var $element = self.$(element);
                $element.toggleClass('is-filtered-out', !fuzzyMatch($element.text().toLowerCase(), filterText.toLowerCase()));
            });
        },

        clearSourceSelection: function() {
            this.sourceCollection.each(function(item) {
                item.unset('listBuilder:isSelected');
            });
            this.toggleControls();
        },

        moveSelectedItems: function() {
            var items = this.sourceCollection.where({
                'listBuilder:isSelected': true
            });
            this.targetCollection.add(items);
            this.sourceCollection.remove(items);
            this.sortLists();
        },

        moveAllItems: function() {
            var items = this.sourceCollection.slice(0);
            this.targetCollection.add(items);
            this.sourceCollection.remove(items);
            this.sortLists();
        },

        clearTargetSelection: function() {
            this.targetCollection.each(function(item) {
                item.unset('listBuilder:isSelected');
            });
            this.toggleControls();
        },

        removeSelectedItems: function() {
            var items = this.targetCollection.where({
                'listBuilder:isSelected': true
            });
            this.sourceCollection.add(items);
            this.targetCollection.remove(items);
            this.sortLists();
        },

        removeAllItems: function() {
            var items = this.targetCollection.slice(0);
            this.sourceCollection.add(items);
            this.targetCollection.remove(items);
            this.sortLists();
        },

        toggleControls: function() {
            var selectedSource = this.sourceCollection.where({
                'listBuilder:isSelected': true
            });

            var selectedTarget = this.targetCollection.where({
                'listBuilder:isSelected': true
            });

            var showSourceControls = !selectedSource.length;
            this.ui.clearSourceSelection.toggle(!showSourceControls);
            this.ui.moveSelectedItems.toggle(!showSourceControls);
            this.ui.moveAllItems.toggle(showSourceControls);

            var showTargetControls = !selectedTarget.length;
            this.ui.clearTargetSelection.toggle(!showTargetControls);
            this.ui.removeSelectedItems.toggle(!showTargetControls);
            this.ui.removeAllItems.toggle(showTargetControls);

            this.ui.moveAllItems.prop('disabled', !this.sourceCollection.length);
            this.ui.removeAllItems.prop('disabled', !this.targetCollection.length);
        },

        sortLists: function() {
            if (this.sourceCollection.comparator) {
                this.sourceCollection.sort();
            }
            if (this.targetCollection.comparator) {
                this.targetCollection.sort();
            }
            this.sourceListRegion.show(this.sourceList);
            this.targetListRegion.show(this.targetList);

            this.toggleControls();
            this.initializeDragAndDrop();
            this.applySearchFilter();
        }
    });

});

